import * as React from 'react';
import * as I18n from 'i18n-js';

import SanitizedRender from './sanitized_render';
import Modal from './modal';

interface IProps {
  availableTermMonths?: (number | null)[] | null;
  buyerPrice: string;
  estimatedMonthlyPayment?: string;
  hideZeroPercentNudge?: boolean;
  maxTermMonth: number;
  zeroPercentFinancing?: boolean;
  buttonLabel?: JSX.Element | React.ReactNode | string;
  lowestAprAtMaxTerm?: number;
}

function AffirmLearnMoreModal({
  availableTermMonths,
  buyerPrice,
  estimatedMonthlyPayment,
  maxTermMonth,
  zeroPercentFinancing,
  buttonLabel,
  lowestAprAtMaxTerm,
}: IProps) {
  const [showDetails, setShowDetails] = React.useState(false);

  const emptyRender = !estimatedMonthlyPayment;

  if (emptyRender) { return null; }

  const toggleDetails = (e) => {
    e.preventDefault();
    e.stopPropagation();

    return setShowDetails(val => !val);
  };

  const closeModal = () => setShowDetails(false);

  const renderOfferDetails = () => {
    const bestPercent = zeroPercentFinancing ? '0' : '10';

    const moreDetails = (() => {
      if (zeroPercentFinancing) {
        return I18n.t('commons.affirmEstimateModal.zeroFinancing.moreOfferDetails', {
          months1: availableTermMonths[0],
          months2: availableTermMonths[1],
          months3: availableTermMonths[2],
        });
      }

      return I18n.t('commons.affirmEstimateModal.moreOfferDetails');
    })();

    return (
      <>
        <div data-offer-more-details className="weight-bold size-110 mobile-mt-2">
          { moreDetails }
        </div>

        <div data-offer-details className="mt-1 mb-2 bdb-1 bd--offwhite pb-2">
          {I18n.t('commons.affirmEstimateModal.offerDetails', {
            estimateAprPercent: lowestAprAtMaxTerm || bestPercent,
            bestPercent,
            maxMonths: maxTermMonth,
            monthlyCost: estimatedMonthlyPayment,
            price: buyerPrice,
          })}
        </div>
      </>
    );
  };

  const renderOfferBody = () => (
    <>
      <div className="d-flex fx-align-center">
        <div className="item2-affirm__benefits-icon item2-affirm__benefits-icon--watch" />
        <div>
          <div className="weight-bold">
            {I18n.t('commons.affirmEstimateModal.quickAndEasyTitle')}
          </div>
          <div className="size-90">
            {I18n.t('commons.affirmEstimateModal.quickAndEasyDescription')}
          </div>
        </div>
      </div>
      <div className="d-flex fx-align-center mt-2">
        <div className="item2-affirm__benefits-icon item2-affirm__benefits-icon--money" />
        <div>
          <div className="weight-bold">
            {I18n.t('commons.affirmEstimateModal.noHiddenFeesTitle')}
          </div>
          <div className="size-90">
            {I18n.t('commons.affirmEstimateModal.noHiddenFeesDescription')}
          </div>
        </div>
      </div>
      <div className="align-center mt-2 weight-bold">
        <SanitizedRender html={
          I18n.t('commons.affirmEstimateModal.atCheckout', {
            logoOpen: '<span class="item2-affirm__logo item2-affirm__logo--modal">',
            logoClose: '</span>',
          })}
        />
      </div>
    </>
  );

  const renderFinePrint = () => (
    <div className="mt-2 pt-2 bdt-1 bd--offwhite size-80">
      <SanitizedRender html={
        I18n.t('commons.affirmEstimateModal.finePrint', {
          linkOpen: '<a href="https://www.affirm.com/faqs" target="_blank">',
          linkClose: '</a>',
        })}
      />
    </div>
  );

  return (
    <>
      <button
        className="affirm-learn-more-modal__trigger"
        type="button"
        onClick={toggleDetails}
      >
        {buttonLabel || I18n.t('commons.affirmEstimateModal.learnMore')}
      </button>
      <Modal
        isOpen={showDetails}
        shouldCloseOnOverlayClick
        paddedBody
        newClose
        onRequestClose={closeModal}
      >
        {renderOfferDetails()}
        {renderOfferBody()}
        {renderFinePrint()}
      </Modal>
    </>
  );
}

export default AffirmLearnMoreModal;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/affirm_learn_more_modal.tsx